<!--  -->
<template>
<div class="account">
    <div class="phone_login">
        <div class="logo">
            <img src="/static/images/logo_login.png" alt="" srcset="" />
        </div>
        <h1>笔杆论文登录</h1>
        <el-form :model="ruleForm" :status-icon="false" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号" prop="mobile">
                <el-input type="text" placeholder="请输入手机号" v-model="ruleForm.mobile" autocomplete="off" class="login_input"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="verifyCode" style="display: flex;">
                <el-input type="text" placeholder="请输入短信验证码" v-model="ruleForm.verifyCode" autocomplete="no" class="login_input"></el-input>
                <button type="button" class="obtain" :disabled="disabled" @click="obtainCode" :style="disabled ? 'color:#999' : ''">
                    {{ disabled ? time + "s后重新发送" : "发送验证码" }}
                </button>
            </el-form-item>
            <el-form-item>
                <button type="button" class="submit" @click="submitForm('ruleForm')"><i class="el-icon-loading" v-if="loading"></i>{{loading?'登录中': '登录'}}</button>
            </el-form-item>
        </el-form>
        <p>登录即代表你已阅读并同意<span @click="service" style="cursor: pointer;">《用户协议》</span></p>
        <p style="margin-top:73px">其他账号登录</p>
        <div class="qqwx">
          <!-- <img @click="qqLogin()" src="/static/images/denglu_qq_default.png" alt="" srcset="" /> -->
          <img src="/static/images/denglu_weixin_default.png" alt="" srcset="" @click=" back()" />
        </div>
    </div>
    <div class=""></div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      disabled: false,
      loading: false,
      codeTime: '',
      time: 60,
      ruleForm: {
        mobile: '',
        // sign: "",
        verifyCode: ''
      },
      rules: {}
    }
  },
  components: {},
  created: function () {
    if (localStorage.getItem('codetime')) {
      var code_time = localStorage.getItem('codetime')
      this.time = code_time - Math.round(new Date().getTime() / 1000)
      if (this.time > 0) {
        this.disabled = true
      }
      this.codeTime = setInterval(() => {
        if (this.time <= 0) {
          this.disabled = false
          clearInterval(this.codeTime)
          localStorage.removeItem('codetime')
        }
        this.time = code_time - Math.round(new Date().getTime() / 1000)
      }, 1000)
    }
  },
  mounted: function () {},
  methods: {
    submitForm: function (formName) {
      this.rules = {
        mobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('*请输入手机号'))
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error('*手机号格式不正确，请重新输入'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        verifyCode: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('*输入验证码'))
            } else {
              this.loading = true
              this.oauthapi.mobile(this.ruleForm).then(res => {
                this.loading = false
                if (res.code == 1001) {
                  callback(new Error('*' + res.msg))
                }
                if (res.code == 0) {
                  localStorage.setItem('token', res.data.token)
                  localStorage.setItem('userId', res.data.userId)
                  localStorage.setItem('isNew', res.data.isNew)
                  /**
                   * 登录成功获取用户信息
                   */
                  this.oauthapi.userInfo().then(res => {
                    localStorage.setItem('userinfo', JSON.stringify(res.data))
                    this.$router.replace({
                      path: this.$route.query.path || '/home'
                    })
                  })
                }
              })
            }
          },
          trigger: 'blur'
        }]
      }
    },
    obtainCode: function () {
      let _this = this
      this.rules = {
        mobile: [{
          validator: (rule, value, callback) => {
            console.log(rule, value)
            if (value == '') {
              callback(new Error('*请输入手机号'))
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error('*手机号格式不正确，请重新输入'))
            } else {
              this.getSend()
            }
          },
          trigger: 'blur'
        }]
      }
    },
    getSend: function () {
      let sendData = {
        businessType: 0,
        mobile: this.ruleForm.mobile
      }
      this.oauthapi.send(sendData).then(res => {
        if (res.code == 0) {
          this.disabled = true
          var time = new Date().getTime() / 1000
          var code_time = 0
          this.time = 60
          if (!localStorage.getItem('codetime')) {
            code_time = Math.round(time) + 60
            localStorage.setItem('codetime', code_time)
            this.codeTime = setInterval(() => {
              if (this.time <= 0) {
                localStorage.removeItem('codetime')
                clearInterval(this.codeTime)
                this.disabled = false
              }
              this.time = code_time - Math.round(new Date() / 1000)
            }, 1000)
          } else {
            code_time = localStorage.getItem('codetime')
            this.codeTime = setInterval(() => {
              if (this.time <= 0) {
                localStorage.removeItem('codetime')
                clearInterval(this.codeTime)
                this.disabled = false
              }
              this.time = code_time - Math.round(new Date() / 1000)
            }, 1000)
          }
        } else if (res.code == 1012) {
          this.$message.error(res.msg)
        }
      })
    },
    back: function () {
      let activeName = 'wx'
      this.$emit('back', activeName)
    },

    // 用户协议
    service () {
      let routeUrl = this.$router.resolve({
        path: '/page/terms_of_service'
      })
      window.open(routeUrl.href, '_blank')
    },

    // qq登录
    qqLogin () {
      this.oauthapi.qqauthorizeurl().then(res => {
        window.open(res.data, '_black')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.account {
    width: 580px;
    display: flex;
    justify-content: center;
    height: 720px;

    .logo {
        margin-top: 40px;
        width: 100%;
        height: 34px;

        img {
            width: 60px;
            height: 34px;
        }
    }

    .phone_login {
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        font-size: 30px;
        font-weight: bold;
        color: #34343a;
        text-align: center;
        margin-top: 60px;
    }

    .obtain {
        position: absolute;
        border: none;
        right: 0;
        background: none;
        color: $btnc;
        height: 100%;
    }

    .submit {
        background: $btnc;
        color: #ffffff;
        width: 350px;
        height: 36px;
        border-radius: 18px;
        margin-top: 40px;
        cursor: pointer;
    }

    p {
        text-align: center;
        color: #989ea2;

        span {
            color: $btnc;
        }
    }

    .qqwx {
        margin-top: 10px;
        text-align: center;

        img {
            margin: 8px;
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login/account.vue